var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"payment-logos"}},[_c('div',{staticClass:"d-flex justify-content-center justify-content-md-start"},[_c('img',{attrs:{"src":require("@/assets/payment-logo-visa-mc.png")}}),_c('img',{attrs:{"src":require("@/assets/payment-logo-twint.png")}})])])
}]

export { render, staticRenderFns }